import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from "@angular/forms";
import { LunaCommonModule } from "../common/common.module";
import { IssuesRoutingModule } from './issues-routing.module';
import { SubmitComplianceComponent } from './components/submit-compliance/submit-compliance.component';
import { WellSelectorComponent } from './components/well-selector/well-selector.component';
import { ProductionReportingComponent } from './components/production-reporting/production-reporting.component';
import { WellProductionEntryComponent } from './components/well-production-entry/well-production-entry.component';
import { WellProductionUploadComponent } from './components/well-production-upload/well-production-upload.component';
import { ReviewComplianceReportComponent } from './components/review-compliance-report/review-compliance-report.component';
import { ReportNotesComponent } from './components/report-notes/report-notes.component';
import { ReviewIssueComponent } from './components/review-issue/review-issue.component';
import { IssueTimelineComponent } from './components/issue-timeline/issue-timeline.component';
import { ReassignIssueComponent } from './components/reassign-issue/reassign-issue.component';
import { IssuesSearchComponent } from './components/issues-search/issues-search.component';
import { CreateIssueComponent } from './components/create-issue/create-issue.component';
import { ComplianceReportResolver } from './resolvers/compliance-report.resolver';
import { ComplianceApplicationResolver } from "./resolvers/compliance-application.resolver";
import { ViewIssuesComponent } from './components/view-issues/view-issues.component';
import { ViewMyIssuesComponent } from './components/view-my-issues/view-my-issues.component';
import { ComplianceSubmissionsComponent } from './components/compliance-submissions/compliance-submissions.component';
import { ElectricLogsComponent } from './components/electric-logs/electric-logs.component';
import { ReviewLogsComponent } from './components/review-logs/review-logs.component';
import { ApplicationNotesComponent } from '../applications/components/application-notes/application-notes.component';
import { ApplicationTimelineComponent } from '../applications/components/application-timeline/application-timeline.component';
import { ApplicationsModule } from '../applications/applications.module';
import { PluggingReportSubmitComponent } from './components/plugging-report-submit/plugging-report-submit.component';
import { PluggingReportReviewComponent } from './components/plugging-report-review/plugging-report-review.component';
import { ComplianceSubmissionsReviewComponent } from './components/compliance-submissions-review/compliance-submissions-review.component'
import { AsDrilledPlatSubmitComponent } from './components/as-drilled-plat/as-drilled-plat-submit/as-drilled-plat-submit.component';
import { UnitizationComponent } from './components/as-drilled-plat/sections/unitization/unitization.component';
import { PlatDocumentationComponent } from './components/as-drilled-plat/sections/plat-documentation/plat-documentation.component';
import { PlatLocationComponent } from './components/as-drilled-plat/sections/plat-location/plat-location.component';
import { LocationPointComponent } from './components/as-drilled-plat/sections/plat-location/location-point/location-point.component';
import { PlatFeesComponent } from './components/as-drilled-plat/sections/plat-fees/plat-fees.component';
import { AsDrilledPlatReviewComponent } from './components/as-drilled-plat/as-drilled-plat-review/as-drilled-plat-review.component';
import { PlatReviewerComponent } from './components/as-drilled-plat/sections/plat-reviewer/plat-reviewer.component'
import { WellStimAdditivesSubmitComponent } from './components/well-stim-additives-submit/well-stim-additives-submit.component';
import { WellStimAdditivesReviewComponent } from './components/well-stim-additives-review/well-stim-additives-review.component';
import { SurfaceHoleAdditiveSubmitComponent } from './components/surface-hole-additive-submit/surface-hole-additive-submit.component';
import { SurfaceHoleAdditiveReviewComponent } from './components/surface-hole-additive-review/surface-hole-additive-review.component';
import { PreliminaryCompletionReportSubmitComponent } from './components/preliminary-completion-report/preliminary-completion-report-submit/preliminary-completion-report-submit.component'
import { PreliminaryCompletionReportReviewComponent } from './components/preliminary-completion-report/preliminary-completion-report-review/preliminary-completion-report-review.component';
import { OwnerWellInfoComponent } from './components/preliminary-completion-report/sections/owner-well-info/owner-well-info.component';
import { WellInformationComponent } from './components/preliminary-completion-report/sections/well-information/well-information.component';
import { CasingAndTubingComponent } from './components/preliminary-completion-report/sections/casing-and-tubing/casing-and-tubing.component';
import { DocumentationComponent } from './components/preliminary-completion-report/sections/documentation/documentation.component';
import { FormationsComponent } from './components/preliminary-completion-report/sections/formations/formations.component';
import { CertificationComponent } from './components/preliminary-completion-report/sections/certification/certification.component';
import { UserUpdatesComponent } from './components/preliminary-completion-report/review-sections/user-updates/user-updates.component';
import { ReceivedDatesComponent } from './components/preliminary-completion-report/review-sections/received-dates/received-dates.component';
import { FormationDataComponent } from './components/preliminary-completion-report/review-sections/formation-data/formation-data.component';
import { FinalCompletionReportComponent } from './components/final-completion-report/final-completion-report.component';
import { CompletionInformationComponent } from './components/final-completion-report/sections/completion-information/completion-information.component';
import { InitialProductionComponent } from './components/final-completion-report/sections/initial-production/initial-production.component';
import { FinalDocumentationComponent } from './components/final-completion-report/sections/final-documentation/final-documentation.component';
import { FinalCompletionReviewComponent } from './components/final-completion-report/final-completion-review/final-completion-review.component'


@NgModule({
    declarations: [
        SubmitComplianceComponent,
        WellSelectorComponent,
        ProductionReportingComponent,
        WellProductionEntryComponent,
        WellProductionUploadComponent,
        ReviewComplianceReportComponent,
        ReportNotesComponent,
        ReviewIssueComponent,
        IssueTimelineComponent,
        ReassignIssueComponent,
        IssuesSearchComponent,
        CreateIssueComponent,
        ViewIssuesComponent,
        ViewMyIssuesComponent,
        ComplianceSubmissionsComponent,
        ElectricLogsComponent,
        ReviewLogsComponent,
        PluggingReportSubmitComponent,
        PluggingReportReviewComponent,
        ComplianceSubmissionsReviewComponent,
        AsDrilledPlatSubmitComponent,
        UnitizationComponent,
        PlatDocumentationComponent,
        PlatLocationComponent,
        LocationPointComponent,
        PlatFeesComponent,
        AsDrilledPlatReviewComponent,
        PlatReviewerComponent,
      
        WellStimAdditivesSubmitComponent,
        WellStimAdditivesReviewComponent,
        SurfaceHoleAdditiveSubmitComponent,
        SurfaceHoleAdditiveReviewComponent,
        PreliminaryCompletionReportSubmitComponent,
        PreliminaryCompletionReportReviewComponent,
        OwnerWellInfoComponent,
        WellInformationComponent,
        CasingAndTubingComponent,
        DocumentationComponent,
        FormationsComponent,
        CertificationComponent,
        UserUpdatesComponent,
        ReceivedDatesComponent,
        FormationDataComponent,
        FinalCompletionReportComponent,
        CompletionInformationComponent,
        InitialProductionComponent,
        FinalDocumentationComponent,
        FinalCompletionReviewComponent

    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        LunaCommonModule,
        IssuesRoutingModule,
        ApplicationsModule
    ],
    providers: [
        ComplianceReportResolver,
        ComplianceApplicationResolver
    ]
})
export class IssuesModule { }
